import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import React, { Dispatch, Fragment, useCallback } from 'react';
import ExpandAccordion from '../../../components/ExpandesAccordion';
import { useTranslation } from 'react-i18next';
import FieldWrapper from '../../../components/formInputs/FieldWrapper';
import InputSkeleton from '../../../components/loaders/InputSkeleton';
import { customSelectStyles } from '../../../utils/SelectStyles';
import { hasPermission } from '../../../utils/HelperFunctions';
import { salesSelectProps } from '../../../utils/selectOptionsProps';
import useModelSelectOptions from '../../../hooks/useModelSelectOptions';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useFormikContext } from 'formik';

export default function CreateOrderLead({ expanded, setExpanded }: { expanded: number; setExpanded: Dispatch<React.SetStateAction<number>> }) {
  const { id } = useParams();
  const { t } = useTranslation();
  const formik = useFormikContext<any>();
  const authData = useSelector((state: any) => state.authData);
  const beforeSalesOptionsMaping = useCallback((options: any) => {
    return options.filter((option: any) => option?.type == 'Sales');
  }, []);
  const { modelOptions: salesOptions, apiDataLoading: salesLoading } = useModelSelectOptions(salesSelectProps(!!id, beforeSalesOptionsMaping));

  console.log(salesOptions, formik.values.sales_id, 'salesOptions');
  return (
    <div className="field-array-container">
      <Accordion
        expanded={expanded == 1}
        onChange={(e) => {
          e.stopPropagation();
          setExpanded(expanded == 1 ? -1 : 1);
        }}
      >
        <AccordionSummary
          sx={{
            '&.Mui-focusVisible': {
              backgroundColor: '#000'
            }
          }}
          aria-controls="panel1a-content"
          id="panel1a-header"
          className={`header-container ${expanded != 1 && 'expand'}`}
        >
          <p>
            <ExpandAccordion expand={expanded == 1} /> {t('customer_details')}
          </p>
        </AccordionSummary>
        <AccordionDetails>
          <div className="inputs_grid">
            {!id && (
              <Fragment>
                {authData?.userData?.type != "Sales" && (
                  <Fragment>
                    {salesLoading ? (
                      <InputSkeleton gridSize={6} />
                    ) : (
                      <FieldWrapper
                        customPadding
                        title={t('sales')}
                        inputPlaceholder={hasPermission(['admins.show']) ? t('sales') : t('no_permission_to_show')}
                        disabled={!hasPermission(['admins.show'])}
                        inputName={`sales_id`}
                        options={salesOptions}
                        selectStyle={customSelectStyles}
                        select
                        search
                        gridSize={6}
                      />
                    )}
                  </Fragment>
                )}
                <FieldWrapper title={t('provider_lead_id')} inputName={`lead_id`} inputPlaceholder={t('provider_lead_id')} input customPadding gridSize={6} />
              </Fragment>
            )}
            <FieldWrapper title={t('first_name')} inputName={`first_name`} inputPlaceholder={t('first_name')} input customPadding disabled={!!id} gridSize={6} />
            <FieldWrapper title={t('last_name')} inputName={`last_name`} inputPlaceholder={t('last_name')} input customPadding disabled={!!id} gridSize={6} />
            <FieldWrapper title={t('email')} inputName={`email`} inputPlaceholder={t('email')} input customPadding disabled={!!id} gridSize={6} />
            <FieldWrapper title={t('phone')} inputName={`mobile`} inputPlaceholder={t('phone')} input customPadding disabled={!!id} gridSize={6} />
            <FieldWrapper title={t('national_id')} inputName={`national_id`} inputPlaceholder={t('national_id')} input customPadding disabled={!!id} gridSize={6} />
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
